(() => {
  const initialize = () => {
    document.querySelectorAll('gallery-carousel').forEach((gallery) => {
      if (gallery.dataset.customThumbnailHeight) return;
      gallery.dataset.customThumbnailHeight = 'true';

      let attempts = 0;

      const setup = () => {
        const thumbnails = gallery.thumbnails;
        const track = gallery.querySelector('.main-carousel .splide__track');

        if (!thumbnails || !track) {
          if (gallery.isConnected && ++attempts < 100) {
            setTimeout(setup, 100);
          }
          return;
        }

        const direction = thumbnails.root
          .querySelector('.splide__track')
          ?.classList.contains('splide__track--ttb');

        if (!direction && window.innerWidth >= 768) return;

        const updateHeight = () => {
          if (!gallery.isConnected) {
            observer.disconnect();
            window.removeEventListener('resize', updateHeight);
            return;
          }

          if (window.innerWidth < 768) return;

          const height = Math.round(track.getBoundingClientRect().height);

          if (height > 0 && thumbnails.options.height !== `${height}px`) {
            thumbnails.options = { height: `${height}px` };
          }
        };

        const observer = new ResizeObserver(updateHeight);
        observer.observe(track);
        window.addEventListener('resize', updateHeight);
        updateHeight();
      };

      setup();
    });
  };

  customElements.whenDefined('gallery-carousel').then(() => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', initialize);
  });
})();